import {
  correctFitBraDetails,
  recommendedBra,
  tooBigBraDetails,
  tooSmallBraDetails,
} from "../constants/formUtils";

export const processBraStats = (cup, age, intensity, band, crop, braType) => {
  let breastSupportRecommended = [];
  const {
    HYBRID,
    CROPTOP_SMALL,
    SPORTSBRA_SMALL,
    SPORTSBRA_MEDIUM,
    SPORTSBRA_LARGE,
    SBCT,
  } = recommendedBra;

  console.log("Processing bra stats");
  console.log(cup, age, intensity, band, crop, braType);

  if (braType === "Crop top") {
    if (age === "< 30") {
      if (["XS", "S"].includes(crop)) {
        breastSupportRecommended = [CROPTOP_SMALL, SPORTSBRA_SMALL, HYBRID];
      }

      if (["M"].includes(crop)) {
        if (intensity === "Small") {
          breastSupportRecommended = [CROPTOP_SMALL, SPORTSBRA_MEDIUM, HYBRID];
        }

        if (intensity === "Moderate" || intensity === "Large") {
          breastSupportRecommended = [HYBRID, SPORTSBRA_MEDIUM];
        }
      }

      if (["L", "XL", "XXL+"].includes(crop)) {
        if (intensity === "Small" || intensity === "Moderate") {
          breastSupportRecommended = [SPORTSBRA_LARGE, HYBRID];
        } else {
          breastSupportRecommended = [SBCT];
        }
      }
    }

    if (age === "30 to 45" || age === "> 45") {
      if (["XS", "S"].includes(crop)) {
        breastSupportRecommended = [CROPTOP_SMALL, SPORTSBRA_SMALL, HYBRID];
      }

      if (["M"].includes(crop)) {
        if (intensity === "Small") {
          breastSupportRecommended = [CROPTOP_SMALL, SPORTSBRA_MEDIUM, HYBRID];
        }

        if (intensity === "Moderate" || intensity === "Large") {
          breastSupportRecommended = [SPORTSBRA_MEDIUM, HYBRID];
        }
      }

      if (["L", "XL", "XXL+"].includes(crop)) {
        if (intensity === "Small") {
          breastSupportRecommended = [SPORTSBRA_LARGE, HYBRID];
        } else {
          breastSupportRecommended = [SBCT];
        }
      }
    }
  } else {
    if (age === "< 30") {
      if (cup === "A" || cup === "B") {
        breastSupportRecommended = [CROPTOP_SMALL, SPORTSBRA_SMALL, HYBRID];
      }

      if (["C", "D"].includes(cup)) {
        if (intensity === "Small") {
          breastSupportRecommended = [CROPTOP_SMALL, SPORTSBRA_MEDIUM, HYBRID];
        }

        if (intensity === "Moderate" || intensity === "Large") {
          breastSupportRecommended = [HYBRID, SPORTSBRA_MEDIUM];
        }
      }

      if (cup >= "DD") {
        if (intensity === "Small") {
          breastSupportRecommended = [SPORTSBRA_LARGE, HYBRID];
        }

        if (intensity === "Moderate" || intensity === "Large") {
          if (
            (band >= 8 && band <= 12) ||
            (band >= 30 && band <= 34) ||
            (band >= 80 && band <= 90)
          ) {
            breastSupportRecommended = [SPORTSBRA_LARGE, HYBRID];
          } else {
            breastSupportRecommended = [SBCT];
          }
        }
      }
    }

    if (age === "30 to 45") {
      if (["A", "B"].includes(cup)) {
        breastSupportRecommended = [CROPTOP_SMALL, SPORTSBRA_SMALL, HYBRID];
      }

      if (["C", "D"].includes(cup)) {
        if (intensity === "Small") {
          breastSupportRecommended = [CROPTOP_SMALL, SPORTSBRA_MEDIUM, HYBRID];
        }

        if (intensity === "Moderate" || intensity === "Large") {
          breastSupportRecommended = [SPORTSBRA_MEDIUM, HYBRID];
        }
      }

      if (cup >= "DD") {
        if (intensity === "Small") {
          breastSupportRecommended = [SPORTSBRA_LARGE, HYBRID];
        }

        if (intensity === "Moderate" || intensity === "Large") {
          if (band <= 12 || band <= 34 || band <= 90) {
            breastSupportRecommended = [SPORTSBRA_LARGE, HYBRID];
          } else {
            breastSupportRecommended = [SBCT];
          }
        }
      }
    }

    if (age === "> 45") {
      if (["A", "B"].includes(cup)) {
        breastSupportRecommended = [CROPTOP_SMALL, SPORTSBRA_SMALL, HYBRID];
      }

      if (["C", "D"].includes(cup)) {
        if (intensity === "Small") {
          breastSupportRecommended = [CROPTOP_SMALL, SPORTSBRA_MEDIUM, HYBRID];
        } else {
          breastSupportRecommended = [SPORTSBRA_MEDIUM, HYBRID];
        }
      }

      if (cup >= "DD") {
        if (intensity === "Small") {
          breastSupportRecommended = [SPORTSBRA_LARGE, HYBRID];
        }

        if (intensity === "Moderate" || intensity === "Large") {
          if (
            (band >= 8 && band <= 10) ||
            (band >= 30 && band <= 32) ||
            (band >= 80 && band <= 85)
          ) {
            breastSupportRecommended = [SPORTSBRA_LARGE, HYBRID];
          } else {
            breastSupportRecommended = [SBCT];
          }
        }
      }
    }

    // AA - any age
    if (cup === "AA") {
      if (intensity === "Small") {
        breastSupportRecommended = [CROPTOP_SMALL];
      }

      if (intensity === "Moderate" || intensity === "Large") {
        breastSupportRecommended = [CROPTOP_SMALL, SPORTSBRA_SMALL];
      }
    }
    return breastSupportRecommended;
  }

  return breastSupportRecommended;
};

export const returnFit = (breastSupportRecommended) => {
  let tooSmall = [];
  let tooBig = [];
  let correctFit = [];

  if (breastSupportRecommended.length === 1) {
    if (
      breastSupportRecommended[0].imageInfo[0].src.includes("croptop-small")
    ) {
      correctFit = [correctFitBraDetails.CROPTOP_SMALL];
      tooSmall = [tooSmallBraDetails.CT_SMALL_MEDIUM];
      tooBig = [tooBigBraDetails.CT_SMALL_MEDIUM];
    } else {
      correctFit = [correctFitBraDetails.SBCT];
      tooSmall = [tooSmallBraDetails.CT_LARGE, tooSmallBraDetails.SB_LARGE];
      tooBig = [tooBigBraDetails.CT_LARGE, tooBigBraDetails.SB_LARGE];
    }
  }
  if (breastSupportRecommended.length === 2) {
    if (breastSupportRecommended[0].imageInfo[0].src.includes("croptop")) {
      tooSmall = [
        tooSmallBraDetails.CT_SMALL_MEDIUM,
        tooSmallBraDetails.SB_SMALL_MEDIUM,
      ];
      tooBig = [tooBigBraDetails.CT_SMALL_MEDIUM, tooBigBraDetails.SB_SMALL];
      correctFit = [
        correctFitBraDetails.CROPTOP_SMALL,
        correctFitBraDetails.SPORTSBRA_SMALL,
      ];
    } else {
      if (breastSupportRecommended[0].imageInfo[0].src.includes("small")) {
        tooSmall = [tooSmallBraDetails.SB_SMALL_MEDIUM];
        tooBig = [tooBigBraDetails.SB_SMALL];
        correctFit = [correctFitBraDetails.SPORTSBRA_SMALL];
      } else if (
        breastSupportRecommended[0].imageInfo[0].src.includes("medium")
      ) {
        tooSmall = [tooSmallBraDetails.SB_SMALL_MEDIUM];
        tooBig = [tooBigBraDetails.SB_MEDIUM];
        correctFit = [correctFitBraDetails.SPORTSBRA_MEDIUM];
      } else {
        tooSmall = [tooSmallBraDetails.SB_LARGE];
        tooBig = [tooBigBraDetails.SB_LARGE];
        correctFit = [correctFitBraDetails.SPORTSBRA_LARGE];
      }
    }
  }
  if (breastSupportRecommended.length === 3) {
    if (breastSupportRecommended[0].imageInfo[0].src.includes("-small")) {
      tooSmall = [
        tooSmallBraDetails.CT_SMALL_MEDIUM,
        tooSmallBraDetails.SB_SMALL_MEDIUM,
      ];
      tooBig = [tooBigBraDetails.CT_SMALL_MEDIUM, tooBigBraDetails.SB_SMALL];
      correctFit = [
        correctFitBraDetails.CROPTOP_SMALL,
        correctFitBraDetails.SPORTSBRA_SMALL,
      ];
    } else if (
      breastSupportRecommended[0].imageInfo[0].src.includes("-medium")
    ) {
      tooSmall = [
        tooSmallBraDetails.CT_SMALL_MEDIUM,
        tooSmallBraDetails.SB_SMALL_MEDIUM,
      ];
      tooBig = [tooBigBraDetails.CT_SMALL_MEDIUM, tooBigBraDetails.SB_MEDIUM];
      correctFit = [
        correctFitBraDetails.CROPTOP_SMALL,
        correctFitBraDetails.SPORTSBRA_MEDIUM,
      ];
    } else {
      tooSmall = [tooSmallBraDetails.CT_LARGE, tooSmallBraDetails.SB_LARGE];
      tooBig = [tooBigBraDetails.CT_LARGE, tooBigBraDetails.SB_LARGE];
      correctFit = [
        correctFitBraDetails.CROPTOP_SMALL,
        correctFitBraDetails.SPORTSBRA_LARGE,
      ];
    }
  }

  return { tooSmall: tooSmall, tooBig: tooBig, correctFit: correctFit };
};

export const returnImageSrcList = (breastSupportRecommended, braPart) => {
  let tooSmall = [];
  let tooBig = [];
  let correctFit = [];

  if (braPart === "Cup") {
    if (
      breastSupportRecommended[0].imageInfo[0].src.includes("croptop-small")
    ) {
      correctFit = [
        `croptop-small-front.jpg`,
        `croptop-small-right.jpg`,
        `sportsbra-small-front.jpg`,
        `sportsbra-small-right.jpg`,
      ];
      tooSmall = [
        `sportsbra-medium-front-toosmall.jpg`,
        `sportsbra-medium-right-toosmall.jpg`,
      ];
      tooBig = [
        `croptop-small-front-toobig.jpg`,
        `croptop-small-right-toobig.jpg`,
      ];
    } else if (
      breastSupportRecommended[0].imageInfo[0].src.includes("medium")
    ) {
      correctFit = [
        `sportsbra-medium-front.jpg`,
        `sportsbra-medium-right.jpg`,
        `hybrid-front.jpg`,
        `hybrid-back.jpg`,
      ];
      tooSmall = [
        `sportsbra-medium-front-toosmall.jpg`,
        `sportsbra-medium-right-toosmall.jpg`,
      ];
      tooBig = [
        `sportsbra-medium-front-toobig.jpg`,
        `sportsbra-medium-right-toobig.jpg`,
      ];
    } else {
      correctFit = [`sportsbra-large-front.jpg`, `sportsbra-large-left.jpg`];
      tooSmall = [
        `sportsbra-large-front-toosmall.jpg`,
        `sportsbra-large-right-toosmall.jpg`,
      ];
      tooBig = [
        `sportsbra-large-front-toobig.jpg`,
        `sportsbra-large-left-toobig.jpg`,
      ];
    }
  }

  if (braPart === "Material") {
    if (
      breastSupportRecommended[0].imageInfo[0].src.includes("croptop-small")
    ) {
      correctFit = [
        `croptop-small-front.jpg`,
        `croptop-small-right.jpg`,
        `croptop-small-back.jpg`,
      ];
    } else if (
      breastSupportRecommended[0].imageInfo[0].src.includes("medium")
    ) {
      correctFit = [
        `sportsbra-medium-front.jpg`,
        `sportsbra-medium-right.jpg`,
        `sportsbra-medium-back.jpg`,
      ];
    } else {
      correctFit = [`hybrid-front.jpg`, `hybrid-right.jpg`, `hybrid-back.jpg`];
    }
  }

  if (braPart === "Underwire") {
    if (
      breastSupportRecommended[0].imageInfo[0].src.includes(
        "croptop-small",
        "medium"
      )
    ) {
      correctFit = [`sportsbra-medium-front.jpg`, `sportsbra-medium-right.jpg`];
      tooSmall = [
        `sportsbra-medium-front-toosmall.jpg`,
        `sportsbra-medium-right-toosmall.jpg`,
      ];
      tooBig = [
        `sportsbra-medium-front-toobig.jpg`,
        `sportsbra-medium-right-toobig.jpg`,
      ];
    } else {
      correctFit = [`sportsbra-large-front.jpg`, `sportsbra-large-left.jpg`];
      tooSmall = [
        `sportsbra-large-front-toosmall.jpg`,
        `sportsbra-large-right-toosmall.jpg`,
      ];
      tooBig = [
        `sportsbra-large-front-toobig.jpg`,
        `sportsbra-large-left-toobig.jpg`,
      ];
    }
  }

  // Merge tooSmall and tooBig into incorrectFit with captions
  const incorrectFit = [
    ...tooSmall.map((src) => ({ src, caption: "Too small" })),
    ...tooBig.map((src) => ({ src, caption: "Too big" })),
  ];

  correctFit = [...correctFit.map((src) => ({ src, caption: "Correct fit" }))];

  return { incorrectFit, correctFit };
};
